
import XHeader from 'vux/src/components/x-header/index.vue'

import { emitAppMethods } from '@/common/utils/common.js'
export default{
data(){
return{

}
},
components: { XHeader },
props: {
isFixed: {
type: Boolean,
default: false
},
title: {
type: String,
default: ''
},
backText: {
type: String,
default: ''
},
preventGoBack: {
type: Boolean,
default: false
},
showBack: {
type: Boolean,
default: false
},
small: {
type: Boolean,
default: false
},
showService: { // 显示客服帮助
type: Boolean,
default: false
},
backPath:{
type: String,
default: ''
}
},
methods: {
handleService() {
this.$router.replace({ path: '/Service' })
},

_clickBack() {
if(this.backPath){
this.$router.replace(this.backPath)
}else{
this.$router.back(-1)
}
if (this.preventGoBack) emitAppMethods('JS_APP_GoBack')

}
}
}



// WEBPACK FOOTER //
// ./src/common/components/g-header/index.vue